import { FaInstagram } from 'react-icons/fa';

import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import {
  Button,
  Col,
  Container,
  Form,
  FormControl,
  Row,
} from 'react-bootstrap';
import { FaFacebookF, FaYoutube } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import { toast } from 'react-toastify';
import { footerLogo5, footerLogo7 } from '../../assets/images';
import { subsription } from '../../DB/DB';
// import board from '../../public/board1.png';
// import vendor from '../../public/vendor.png';
// import Logo from '../LogoTransparent.png';
function Footer() {
  const router = useRouter();
  const contactEmail = router.asPath.includes('weight-loss')
    ? 'support@24hrdoc.com'
    : 'services@24hrdoc.com';

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData(e.target);
    let response = await subsription({ email: data.get('email') });

    if (response && response == 201)
      toast.success('Your email has been added to our Subscriber List');
    else
      toast.error(
        'Could not add the email to Subscriber List, please try again.'
      );
  };
  return (
    //**New Implementation of Footer */
    <footer className='tw-mx-auto tw-w-[92%] lg:tw-w-[83%] 2xl:tw-w-[90rem]'>
      <div className='footerNew'>
        <Container
          style={{ margin: '0', padding: '0' }}
          fluid
          className='theFooterLayout'
        >
          <Row style={{ margin: '0', padding: '0' }}>
            {/* <p className='footerParaTop'>
              <ul className='customList'>
                <li>
                  24hrdoc is not a pharmacy. We do not carry or ship medicines.
                  Online Doctor Prescriptions are sent electronically to your
                  pharmacy after an online medical consultation.
                </li>
                <li>
                  Similar to a doctor&apos;s office, our consultation fee does
                  not include the cost of your medication.
                </li>
              </ul>
            </p> */}
          </Row>
          <hr className='theHorizontalRunner' />
          <Row className='formDiv'>
            <Col style={{ margin: '0', padding: '0' }}>
              <p className='formPara'>
                Sign up and be the first one to know about our discounted rates.
              </p>
              <p className='formParaLG'>
                Sign up and be the first one to know
                <br /> about our discounted rates.
              </p>
            </Col>
            <Col style={{ margin: '0', padding: '0' }}>
              <Form onSubmit={handleSubmit} className='form'>
                <FormControl
                  placeholder='Enter Your Email'
                  aria-label='Email'
                  aria-describedby='basic-addon2'
                  className='formInput'
                  type='email'
                  name='email'
                />
                <Button
                  variant='dark'
                  id='button-addon2'
                  className='formBtn'
                  type='submit'
                  name='subscribe to email button'
                >
                  Subscribe
                </Button>
              </Form>
            </Col>
          </Row>
          <hr className='theHorizontalRunner' />
          <Row className='linksDiv'>
            <Col lg={4} className='rightCol'>
              <Row className='iconRow'>
                {socialLinks.map((item) => (
                  <Col key={item.name} className='iconCol' xs='auto'>
                    <div className='iconBg'>
                      <Link
                        legacyBehavior={true}
                        href={item.address}
                        aria-label={item.name}
                      >
                        <a
                          aria-label={item.name}
                          target='_blank'
                          rel='noopener noreferrer'
                        >
                          <item.Icon className='iconStyle' />
                        </a>
                      </Link>
                    </div>
                  </Col>
                ))}
              </Row>
              <Row>
                <p className='footerPara'>
                  No more waiting to see a doctor for your health and medical
                  needs. You can now get the most affordable online doctor
                  visits through our telehealth services.{' '}
                </p>
                <p className='footerPara'>
                  Talk to a real doctor today for as low as $39.99. No copays.
                  No hidden fees. No insurance needed.
                </p>
              </Row>
              <Row>
                <Col>
                  <div>
                    {' '}
                    <Image
                      alt='footerLogo1'
                      src={footerLogo5}
                      width={58}
                      height={58}
                    />{' '}
                  </div>
                </Col>
                <Col>
                  <div>
                    {' '}
                    {/* LegitScript's own embed code wraps the seal in this
                        link, so it opens our certification status page.
                        The seal was pasted in without the anchor, which
                        left the border='0' below with nothing to suppress
                        until now. */}
                    <a
                      href='https://www.legitscript.com/websites/?checker_keywords=24hrdoc.com'
                      target='_blank'
                      rel='noopener noreferrer'
                      title='Verify LegitScript Approval for www.24hrdoc.com'
                    >
                      <img
                        src={`https://static.legitscript.com/seals/874668.png`}
                        alt='Verify Approval for www.24hrdoc.com'
                        width='58'
                        height='58'
                        border='0'
                      />
                    </a>
                  </div>
                </Col>
                <Col>
                  <div>
                    {' '}
                    <Image
                      alt='footerLogo1'
                      src={footerLogo7}
                      width={58}
                      height={58}
                    />{' '}
                  </div>
                </Col>
              </Row>
            </Col>
            <Col lg={8}>
              <Row>
                {' '}
                <Col className='nestedDiv' xs={6} md={2}>
                  <p className='footerTag'>GENERAL</p>
                  <div className='list'>
                    {generalLinks.map((item) => (
                      <Link
                        key={item.name}
                        legacyBehavior={true}
                        href={item.link}
                        passHref
                      >
                        <a>
                          <p className='footerLink'>{item.name}</p>
                        </a>
                      </Link>
                    ))}
                  </div>
                </Col>
                <Col className='nestedDiv' xs={6} md={2}>
                  <p className='footerTag'>LEARN</p>
                  <div className='list'>
                    {learnLinks.map((item) => (
                      <Link
                        key={item.name}
                        legacyBehavior={true}
                        href={item.link}
                        passHref
                      >
                        <a className='footerLink'> {item.name}</a>
                      </Link>
                    ))}
                  </div>
                </Col>
                <Col className='nestedDiv' xs={6} md={2}>
                  <p className='footerTag'>MORE</p>
                  <div className='list'>
                    {moreLinks.map((item) => (
                      <Link
                        key={item.name}
                        legacyBehavior={true}
                        href={item.link}
                        passHref
                      >
                        <a className='footerLink'> {item.name}</a>
                      </Link>
                    ))}
                    <Link legacyBehavior={true} href='/sitemap' passHref>
                      <a className='footerLink'> Sitemap</a>
                    </Link>
                  </div>
                </Col>
                <Col className='nestedDiv' xs={6} md={3}>
                  <p className='footerTag'>LEGAL</p>
                  <div className='list'>
                    {legalLinks.map((item) => (
                      <Link
                        key={item.name}
                        legacyBehavior={true}
                        href={item.link}
                        passHref
                      >
                        <a>
                          <p className='footerLink'>{item.name}</p>
                        </a>
                      </Link>
                    ))}
                  </div>
                </Col>
                <Col className='nestedDiv' xs={12} md={3}>
                  <p className='footerTag'>CONNECT</p>
                  <div className='list'>
                    <a href={`mailto:${contactEmail}`}>
                      <p className='footerLink'>
                        <span className='label'>E</span>
                        <span>:</span>
                        <span> {contactEmail}</span>
                      </p>
                    </a>
                    <a href='tel:+18662034555'>
                      <p className='footerLink'>
                        <span className='label'>C</span>
                        <span>:</span>
                        <span> 866-203-4555</span>
                      </p>
                    </a>
                    <p className='footerLink'>
                      <span className='label'>T</span>
                      <span>:</span>
                      <span> Monday-Sunday (08:00 AM to 11:00 PM)</span>
                    </p>
                    <a
                      href='https://www.google.com/maps/search/?api=1&query=3050+Post+Oak+Blvd,+Houston,+TX+77056'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      <p className='footerLink'>
                        <span className='label'>L</span>
                        <span>:</span>
                        <span> 3050 Post Oak Blvd, Houston, TX 77056</span>
                      </p>
                    </a>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
      <div className='bottom'>
        <p>© {new Date().getFullYear()} 24hrdoc LLC. All Rights Reserved</p>
        <p>24hrdoc is a registered Trademark of The 24hrdoc, LLC.</p>
      </div>
    </footer>
  );
}

export default Footer;
const generalLinks = [
  { id: 1, name: 'All Conditions', link: '/services' },
  { id: 2, name: 'Sexual Health', link: '/sexual-diseases' },
  // Third-party programs (ED / weight loss / microdosing) disabled — code
  // preserved under _programs/. Uncomment to re-enable.
  // { id: 3, name: 'Weight Loss', link: '/weight-loss' },
  // { id: 4, name: 'Microdosing', link: '/microdosing' },
];
const learnLinks = [
  { id: 1, name: 'About Us', link: '/about' },
  { id: 2, name: 'Brand Facts', link: '/brand-facts' },
  { id: 3, name: 'FAQS', link: '/faqs' },
  { id: 4, name: 'Blog', link: '/blog' },
];
const moreLinks = [
  { id: 1, name: 'Subscribe & save', link: '/subscribe' },
  { id: 2, name: 'Careers', link: '/careers' },
  { id: 3, name: 'Reviews', link: '/reviews' },
  { id: 4, name: 'Refill Prescription', link: '/prescription-refill' },
  { id: 5, name: 'Contact Us', link: '/contact-us' },
];
const legalLinks = [
  { id: 1, name: 'Privacy Policy', link: '/privacy-policy' },
  { id: 2, name: 'Refund Policy', link: '/refund-policy' },
  { id: 3, name: 'Terms & Conditions', link: '/terms-conditions' },
];
const socialLinks = [
  {
    id: 1,
    name: 'Facebook',
    Icon: FaFacebookF,
    address:
      'https://www.facebook.com/people/24-HR-DOC/100091804954061/?mibextid=ZbWKwL',
  },
  {
    id: 2,
    name: 'Instagram',
    Icon: FaInstagram,
    address: 'https://www.instagram.com/24hrdoc_/?igshid=YmMyMTA2M2Y%3D',
  },
  {
    id: 3,
    name: 'Twitter',
    Icon: FaXTwitter,
    address: 'https://x.com/24HRDoc1',
  },

  {
    id: 5,
    name: 'Youtube',
    Icon: FaYoutube,
    address: 'https://www.youtube.com/channel/UCYxLi6Vy_afwIda8HA_hV8Q',
  },
];
